<p class="font-app-light text-darkest">
  {{ "passwordMessages.passwordRulesInfo" | translate }}
</p>
<ul class="list-disc list-inside ml-4 font-app-light text-darkest">
  <li>{{ "passwordMessages.lowercase" | translate }}</li>
  <li>{{ "passwordMessages.uppercase" | translate }}</li>
  <li>{{ "passwordMessages.numeric" | translate }}</li>
  <li>{{ "passwordMessages.symbols" | translate }}</li>
</ul>

